import React from 'react';

// options: https://github.com/Typeform/embed/blob/main/packages/embed/README.md#options
import { Widget } from '@typeform/embed-react'

const TypeformBuilder: React.FC<{ typeformData?: Queries.TypeformBlockFragment }> = ({ typeformData }) => {

    if (!typeformData) return null;

    // check typeform data
    if (!typeformData.typeformForm?.typeform) return null;

    // TODO: investigate other typeform options. See https://github.com/Typeform/embed/blob/main/packages/embed/README.md#options
    return (
        <div className="pattern pattern--pad pattern--has-watermark bg-brand-orange">
            <div className="container container--md">
                {typeformData.typeformForm?.title && <h3>{typeformData.typeformForm?.title}</h3>}
                <Widget id={typeformData.typeformForm.typeform} autoResize={true} />
            </div>
        </div>
    );
}

export default TypeformBuilder;
